/* ============================================================
   Kasuwa theme — original marketplace design
   Storefront interactions: drawers, hero carousel, deal zones,
   gallery, variant pills, cart drawer (Shopify AJAX API).
   ============================================================ */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var money = function (cents) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.KW && window.KW.currency) || 'USD' });
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- Promo bar dismiss ---------- */
  $$('[data-promo-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var bar = btn.closest('[data-promo-bar]');
      if (bar) bar.style.display = 'none';
      try { sessionStorage.setItem('kw_promo_dismissed', '1'); } catch (e) {}
    });
  });
  try {
    if (sessionStorage.getItem('kw_promo_dismissed') === '1') {
      var bar = $('[data-promo-bar]');
      if (bar) bar.style.display = 'none';
    }
  } catch (e) {}

  /* ---------- Departments dropdown (desktop) ---------- */
  $$('[data-catdrop]').forEach(function (drop) {
    var btn = $('[data-catdrop-btn]', drop);
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var wasOpen = drop.classList.contains('open');
      $$('[data-catdrop].open').forEach(function (d) { d.classList.remove('open'); });
      if (!wasOpen) drop.classList.add('open');
    });
  });
  document.addEventListener('click', function () {
    $$('[data-catdrop].open').forEach(function (d) { d.classList.remove('open'); });
  });

  /* ---------- Mobile drawer ---------- */
  var drawer = $('[data-drawer]');
  var scrim = $('[data-scrim]');
  function openDrawer() { if (drawer) drawer.classList.add('open'); if (scrim) scrim.classList.add('show'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (drawer) drawer.classList.remove('open'); if (scrim) scrim.classList.remove('show'); document.body.style.overflow = ''; }
  $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (scrim) scrim.addEventListener('click', function () { closeDrawer(); closeCart(); });

  /* ---------- Hero carousel ---------- */
  $$('[data-promo]').forEach(function (promo) {
    var slides = $$('[data-promo-slide]', promo);
    var dotsWrap = $('[data-promo-dots]', promo);
    if (slides.length < 2) return;
    var idx = 0, timer = null;
    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      if (dotsWrap) $$('[data-promo-dot]', dotsWrap).forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'kw-hero__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('data-promo-dot', '');
        d.setAttribute('aria-label', 'Slide ' + (i + 1));
        d.addEventListener('click', function () { go(i); restart(); });
        dotsWrap.appendChild(d);
      });
    }
    function restart() { if (timer) clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, 6000); }
    restart();
  });

  /* ---------- Deal zone carousels ---------- */
  $$('[data-cpanel]').forEach(function (panel) {
    var track = $('[data-cpanel-track]', panel);
    if (!track) return;
    $$('[data-cpanel-prev]', panel).forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    });
    $$('[data-cpanel-next]', panel).forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    });
  });

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach(function (gal) {
    var main = $('[data-gallery-main] img', gal);
    $$('[data-gallery-thumb]', gal).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-gallery-thumb]', gal).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (main && btn.dataset.full) {
          main.src = btn.dataset.full;
          if (btn.dataset.alt) main.alt = btn.dataset.alt;
        }
      });
    });
  });

  /* ---------- Variant pills -> hidden variant select ---------- */
  $$('[data-variant-pills]').forEach(function (wrap) {
    var form = wrap.closest('form');
    var select = form ? form.querySelector('select[name="id"]') : null;
    if (!select) return;
    var jsonEl = document.querySelector('[data-product-json]');
    var data = null;
    try { data = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (e) { data = null; }

    function selectedOptions() {
      return $$('[data-option-index]', wrap).map(function (g) {
        var r = g.querySelector('input[type="radio"]:checked');
        return r ? r.value : null;
      });
    }
    function findVariant() {
      if (!data || !data.variants) return null;
      var opts = selectedOptions();
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v['option' + (j + 1)] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
    function applyVariant(v) {
      if (!v) return;
      select.value = v.id;
      var priceEl = $('[data-product-price]');
      if (priceEl) {
        priceEl.innerHTML = money(v.price) + (v.compare_at_price && v.compare_at_price > v.price
          ? '<span class="kw-product__compare">' + money(v.compare_at_price) + '</span>' : '');
      }
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) btn.disabled = !v.available;
    }
    $$('input[type="radio"]', wrap).forEach(function (radio) {
      radio.addEventListener('change', function () { applyVariant(findVariant()); });
    });
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var priceEl = $('[data-product-price]');
      if (priceEl && opt && opt.dataset.price) {
        var p = parseInt(opt.dataset.price, 10);
        var c = opt.dataset.compare ? parseInt(opt.dataset.compare, 10) : 0;
        priceEl.innerHTML = money(p) + (c > p ? '<span class="kw-product__compare">' + money(c) + '</span>' : '');
      }
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) btn.disabled = !!(opt && opt.disabled);
    });
  });

  /* ---------- Quantity steppers ---------- */
  $$('[data-cart-qty-minus],[data-cart-qty-plus]').forEach(function (b) {
    b.addEventListener('click', function () {
      var wrap = b.closest('.kw-qty');
      var input = wrap ? wrap.querySelector('input[name="quantity"]') : null;
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v += b.hasAttribute('data-cart-qty-plus') ? 1 : -1;
      input.value = Math.max(1, v);
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = $('[data-cartdrawer]');
  function openCart() { if (cartDrawer) cartDrawer.classList.add('open'); if (scrim) scrim.classList.add('show'); }
  function closeCart() { if (cartDrawer) cartDrawer.classList.remove('open'); if (scrim && !(drawer && drawer.classList.contains('open'))) scrim.classList.remove('show'); }
  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(openCart); });
  });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeDrawer(); } });

  function cartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  function lineItemHTML(item) {
    var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') + '" alt="" loading="lazy">' : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="kw-lineitem__variant">' + item.variant_title + '</p>' : '';
    return '<div class="kw-lineitem" data-key="' + item.key + '">' +
      img +
      '<div class="kw-lineitem__info">' +
        '<p class="kw-lineitem__title">' + item.product_title + '</p>' + variant +
        '<span class="kw-lineitem__qty">' +
          '<button type="button" data-qty="-1" aria-label="Decrease">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty="1" aria-label="Increase">+</button>' +
        '</span>' +
      '</div>' +
      '<div class="kw-lineitem__right">' +
        '<span class="kw-lineitem__price">' + money(item.final_line_price) + '</span>' +
        '<button type="button" class="kw-cart-remove" data-remove>Remove</button>' +
      '</div>' +
    '</div>';
  }

  function renderCart(cart) {
    cartCount(cart.item_count);
    var itemsWrap = $('[data-cartdrawer-items]');
    var foot = $('[data-cartdrawer-foot]');
    if (!itemsWrap) return;
    if (!cart.items.length) {
      itemsWrap.innerHTML = '<div class="kw-cartdrawer__empty"><p>Your cart is empty.</p></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    itemsWrap.innerHTML = cart.items.map(lineItemHTML).join('');
    if (foot) {
      foot.style.display = '';
      var sub = $('[data-cartdrawer-subtotal]');
      if (sub) sub.textContent = money(cart.total_price);
    }
    $$('[data-qty]', itemsWrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('[data-key]');
        var qtyEl = row.querySelector('.kw-lineitem__qty span');
        var q = parseInt(qtyEl.textContent, 10) + parseInt(b.dataset.qty, 10);
        changeQty(row.dataset.key, Math.max(0, q));
      });
    });
    $$('[data-remove]', itemsWrap).forEach(function (b) {
      b.addEventListener('click', function () {
        changeQty(b.closest('[data-key]').dataset.key, 0);
      });
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { return { item_count: 0, items: [] }; });
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  /* add to cart forms */
  $$('[data-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-add-to-cart]', form);
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { openCart(); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = orig; } });
    });
  });

  /* ---------- Sort select ---------- */
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  });

  /* ---------- Mobile filter toggle ---------- */
  $$('[data-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var f = document.getElementById(btn.getAttribute('aria-controls'));
      if (f) f.classList.toggle('open');
    });
  });

  /* price filter apply */
  $$('[data-price-apply]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-price-filter]');
      var min = wrap.querySelector('[data-price-min]').value;
      var max = wrap.querySelector('[data-price-max]').value;
      var url = new URL(btn.dataset.base || window.location.href, window.location.origin);
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      if (min) url.searchParams.set('filter.v.price.gte', min);
      if (max) url.searchParams.set('filter.v.price.lte', max);
      window.location.href = url.toString();
    });
  });

  /* initial cart count */
  refreshCart();
})();
